// Use a regex to trim floating-point decimals for IE10.
// When dropping IE10 support, just replace this call with Number.prototype.toLocaleString
export default (number)=> number.toLocaleString().replace(/\D\d\d$/, '');